// reducer.js
import * as constants from './constants';

const INITIAL_STATE = {
  dataGTM: {},
  dataBranch: {},
  pageBranch: {},
  dataProduct: {},
  dataNewCar: {},
  dataCoupon: {},
  dataQuicklink: {},
  categoryService: null,
  isGTMReady: false,
  dataTrendingCar: {},
  dataSimulationCredit: null,
  dataGetAdviceUsedCar: null,
};

const GTMReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.SET_GTM:
      return { ...state, dataGTM: action.payload };
    case constants.SET_DATA_BRANCH:
      return { ...state, dataBranch: action.payload };
    case constants.SET_PAGE_BRANCH:
      return { ...state, pageBranch: action.payload };
    case constants.SET_DATA_PRODUCT:
      return { ...state, dataProduct: action.payload };
    case constants.SET_DATA_NEW_CAR:
      return { ...state, dataNewCar: action.payload };
    case constants.SET_FILTER_COUPON:
      return { ...state, dataCoupon: action.payload };
    case constants.SET_CATEGORY_SERVICE:
      return { ...state, categoryService: action.payload };
    case constants.SET_IS_GTM_READY:
      return { ...state, isGTMReady: action.payload };
    case constants.SET_DATA_QUICKLINK:
      return { ...state, dataQuicklink: action.payload };
    case constants.SET_DATA_TRENDING_CAR:
      return { ...state, dataTrendingCar: action.payload };
    case constants.SET_DATA_SIMULATION_CREDIT:
      return { ...state, dataSimulationCredit: action.payload };
    case constants.RESET_DATA_SIMULATION_CREDIT:
      return { ...state, dataSimulationCredit: action.payload };
    case constants.SET_DATA_GET_ADVICE_USED_CAR:
      return { ...state, dataGetAdviceUsedCar: action.payload };
    default:
      return state;
  }
};

export default GTMReducer;
